// ===================================================
// errorLogger.js — 앱 에러를 Supabase에 자동 기록하는 유틸
//
// 역할:
//   - UX 오류(로딩 무한대기, API 실패 등)를 error_logs 테이블에 저장합니다.
//   - 어드민 화면에서 이 로그를 조회해 버그 원인을 파악합니다.
//   - 로깅 자체가 실패해도 앱 동작에는 영향이 없도록 설계됩니다.
//
// 사용 전 Supabase에서 아래 SQL을 실행해 테이블을 만들어야 합니다:
//   → supabase/migrations/create_error_logs.sql 참고
// ===================================================

import { supabase } from '../supabase';

/**
 * 에러를 Supabase error_logs 테이블에 기록합니다.
 *
 * @param {object} params
 * @param {string}      params.action     - 에러가 발생한 함수/액션 이름 (예: 'handleLandingNext')
 * @param {Error|string} params.error     - 발생한 에러 객체 또는 메시지
 * @param {string}      [params.screen]   - 에러가 발생한 화면 (예: 'landing', 'qa')
 * @param {object}      [params.context]  - 추가 맥락 정보 (예: { mode: 'diary' })
 * @param {number}      [params.durationMs] - 작업 시작부터 에러까지 걸린 시간(ms)
 */
export async function logError({ action, error, screen = null, context = null, durationMs = null }) {
  try {
    // 현재 로그인 유저 ID 조회 (비로그인 시 null로 저장)
    const { data: { session } } = await supabase.auth.getSession();
    const userId = session?.user?.id ?? null;

    await supabase.from('error_logs').insert({
      user_id:       userId,
      screen:        screen,
      action:        action,
      error_message: error?.message || String(error),
      context:       context ?? null,
      duration_ms:   durationMs ?? null,
    });
  } catch {
    // 로깅 실패 자체는 무시 — 앱 동작에 절대 영향을 주면 안 됨
  }
}
